module.exports = __webpack_public_path__ + "static/media/beta2.797b28eb.jpg";